import { cloneElement, type PropsWithChildren, type ReactElement, type ReactNode } from 'react';

/**
 * Flattens an array of React elements by extracting their nested children and returning a new array.
 * For each child, a cloned element with `type: 'group'` and no children is added to the result,
 * followed by all of its nested children.
 *
 * @param children - An array of React elements with a `type` prop and possible nested children.
 * @returns A flattened array of React nodes, including cloned group elements and their nested children.
 */
export const flattenChildren = (children: ReactElement<PropsWithChildren<{ type: string }>>[]) => {
  return children.reduce<ReactNode[]>((result, child) => {
    const {
      props: { children: nestedChildren = [] },
    } = child;

    result.push(cloneElement(child, { type: 'group' }, []));
    result.push(...(nestedChildren as ReactElement[]));

    return result;
  }, []);
};
